/**
 * Shows the collection info in the infoPanel
 */
class CollectionInfo extends BaseInfoPanel {

	/**
	 *
	 */
	public collection: CollectionData;

	/**
	 * True if cancelling the inline edit
	 * @private
	 */
	private cancelEdit: boolean;

	/**
	 * HTML Element that shows 'XX item(s) in {collection name}'
	 * @private
	 */
	private numHits: HTMLElement;

	/**
	 * Collection thumbnail
	 * @private
	 */
	private thumbnail: HTMLImageElement;

	/**
	 * Event listener
	 * @private
	 */
	private eventListener: () => void;


	/**
	 *
	 * @param collection
	 */
	constructor(collection: CollectionData) {
		super();
		this.collection = collection;
		this.view();
		this.setUpEvents();
		this.removeActiveStates();
	}

	/**
	 * Set up events
	 * @protected
	 */
	protected setUpEvents() {
		this.eventListener = this.handleEvents.bind(this);
		EVENT.attach(document,'CollectionInfo', this.eventListener);
	}

	/**
	 * Edit collection name and description
	 * @param type
	 * @private
	 */
	private edit(type: string) {
		let staticEl = document.getElementById('info-' + type),
			editEl = <HTMLInputElement>document.getElementById('info-edit-' + type);

		if (iwCore.hasClass(staticEl, 'edit-hide')) {
			iwCore.removeClassName(staticEl, 'edit-hide');
			iwCore.addClassName(editEl, 'edit-hide');

			if (!this.cancelEdit) {
				iwCore.ajax({
					type: 'post',
					dataType: 'json',
					url: '/collection/metadataupdate',
					data: {
						id: this.collection.id,
						fieldID: type,
						value: editEl.value
					},
					success: this.successTitleChange.bind(this, type, editEl.value),
					beforeSend: () => iwCore.loading(true),
					complete: () => iwCore.loading(false),
					error: () => iwNotifications.error(iwi18n.gettext(undefined, 'Error saving %1', type)),
				});
			}
		} else {
			iwCore.addClassName(staticEl, 'edit-hide');
			iwCore.removeClassName(editEl, 'edit-hide');
			editEl.value = staticEl.textContent;
			// .focus() creates a lag in translations that's unavoidable without a brief wait
			setTimeout(() => {
				editEl.focus();
				editEl.select();
			}, 500);
		}

		this.cancelEdit = false;
	}

	/**
	 *
	 * @param type
	 * @param newValue
	 * @param data
	 * @private
	 */
	private successTitleChange(type: string, newValue: string, data: any) {
		if (data.success) {
			let staticEl = document.getElementById('info-' + type);
			if (staticEl) {
				staticEl.textContent = newValue;
			}

			if (type === 'title') {
				this.collection.title = newValue;
				EVENT.custom('InfoPanel', {titleChange: true, value: newValue});
			}

			if (type === 'description') {
				this.collection.description = newValue;
				EVENT.custom('InfoPanel',{titleChange: false});
			}
		} else {
			iwNotifications.error(data.error || iwi18n.gettext(undefined, 'Error saving %1', iw.collectionsName));
		}
	}

	/**
	 *
	 * @private
	 */
	private removeActiveStates() {
		let item = document.getElementsByClassName('results-tile'),
			listItem = document.getElementsByClassName('list-item'),
			container = document.getElementsByClassName('results-view');


			if(container[0].classList.contains('results-view--list')) {
				//List view
				for (let i = 0, l = listItem.length; i < l; i++) {
					if (listItem[i].classList.contains('is-active')) {
						iwCore.removeClassName(listItem[i], 'is-active');
					}
				}
			} else {
				//Grid view
				for (let i = 0, l = item.length; i < l; i++) {
					if (item[i].classList.contains('is-active')) {
						iwCore.removeClassName(item[i], 'is-active');
					}
				}
			}
	}

	/**
	 * Handle incoming events
	 * @param e
	 * @private
	 */
	private handleEvents(e: CustomEvent) {
		switch (e.detail.action) {
			case 'update':
				this.thumbnail.src = this.getThumb();
				this.numHits.textContent = iwi18n.ngettext('collections', '%1 item in %2', '%1 items in %2', this.collection.numHits, iw.collectionsName);
				break;
			case 'title':
				this.edit('title');
				break;
			case 'description':
				this.edit('description');
				break;
		}
	}

	/**
	 *
	 * @protected
	 */
	protected view() {
		this.frag = document.createDocumentFragment();
		this.numHits = iwUI.createEl('div', {class: 'iPanel-numItems'});

		let infoHeader = iwUI.createEl('DIV', {class: 'iPanel__header'}),
			infoBody = iwUI.createEl('DIV', {class: 'iPanel__body'}),
			infoFooter = iwUI.createEl('DIV', {class: 'iPanel__footer'}),
			title = iwUI.createEl('h2', {class: 'iPanel-title', id: 'info-title'}),
			titleLbl = iwUI.createEl('label', {class: 'iPanel-title-lbl', for: 'info-edit-title'}),
			titleEdit = iwUI.createEl('input', {class: 'iPanel-title edit-hide', id: 'info-edit-title', maxlength: 255}),
			iPanelDate = iwUI.createEl('DIV', {class: 'iPanel__date'}),
			iPanelCreateDate = iwUI.createEl('TIME', {class: 'iPanel__date-item', datetime: this.collection.accessibilityCreationDate}),
			iPanelEditDate = iwUI.createEl('TIME', {class: 'iPanel__date-item', datetime: this.collection.accessibilityModifiedDate}),
			iPanelCreateDateTxt = iwUI.createEl('P', {class: 'iPanel__date-txt'}),
			iPanelEditDateTxt = iwUI.createEl('P', {class: 'iPanel__date-txt'}),
			descriptionWrap = iwUI.createEl('div', {class: 'iPanel-info'}),
			description = iwUI.createEl('p', {class: 'iPanel-desc', id: 'info-description'}),
			descLbl = iwUI.createEl('label', {class: 'iPanel-desc-lbl', for: 'info-edit-description'}),
			descriptionEdit = iwUI.createEl('textarea', {class: 'iPanel-desc edit-hide', id: 'info-edit-description', maxlength: 255}),
			mediaTypesWrap = iwUI.createEl('DIV', {class: 'iPanel-types iw_tool_tip_link'}),
			owner = iwUI.createEl('div', {class: 'owner-icon owner-icon--iPanel'}),
			dateEditedLbl = iwUI.createEl('P', {class: 'iPanel__date-lbl'}),
			dateCreatedLbl = iwUI.createEl('P', {class: 'iPanel__date-lbl'}),
			mediaTypesString,
			mainContent = iwUI.createEl('div', {class: 'iPanel-content'});

		this.thumbnail = iwUI.createEl('img', {
			class: 'iPanel-img' + (this.collection.thumbnail ? '' : ' iPanel-img--empty'),
			src: this.getThumb(),
			alt: iwi18n.gettext('collections', '%1 cover image - %2', iw.collectionsName, this.collection.title),
			onerror: `this.src="${iwUI.imageFallback('default')}";`
		});

		for (let i = 0, l = this.collection.mediaTypes.length; i < l; i++) {
			mediaTypesString = this.collection.mediaTypes.join(', ');
			mediaTypesWrap.append(iwUI.createEl('div', {class: 'media-type media-type--iPanel media-type--' +  this.collection.mediaTypes[i].toLowerCase(), 'aria-hidden': 'true'}));
		}

		mediaTypesWrap.setAttribute('data-tool-tip', iwi18n.gettext('collections', 'This %1 contains media type(s): %2', iw.collectionsName, mediaTypesString));
		mediaTypesWrap.setAttribute('aria-label', iwi18n.gettext('collections', 'This %1 contains media type(s): %2', iw.collectionsName, mediaTypesString));
		title.textContent = this.collection.title;
		owner.textContent = this.collection.owner.slice(0, 2).toUpperCase();
		iPanelCreateDateTxt.textContent = this.collection.creationDate;
		iPanelEditDateTxt.textContent = this.collection.modifiedDate;
		dateEditedLbl.textContent = iwi18n.gettext('collections', 'Edited:');
		dateCreatedLbl.textContent = iwi18n.gettext('collections', 'Created:');
		description.textContent = this.collection.description || iwi18n.gettext('collections', 'No description set for this %1', iw.collectionsName);
		this.numHits.textContent = iwi18n.ngettext('collections', '%1 item in %2', '%1 items in %2', this.collection.numHits, iw.collectionsName);
		titleLbl.textContent = iwi18n.gettext('collections', 'Edit %1 name', iw.collectionsName);
		descLbl.textContent = iwi18n.gettext('collections', 'Edit %1 description', iw.collectionsName);

		owner.setAttribute('data-tool-tip', this.collection.owner);
		owner.classList.add('iw_tool_tip_link');

		if (owner.textContent === '') {
			owner.classList.add('is-empty');
		}
		EVENT.attach(owner, 'click', (e: MouseEvent) => {
			iwCore.copyToClipboard(this.collection.owner);
			iwNotifications.alert(iwi18n.gettext(undefined, "Creators email copied to your clipboard"), 'Copy');
			e.preventDefault();
			e.stopPropagation();
		});

		EVENT.attach(titleEdit, 'blur', () => this.edit('title'));
		EVENT.attach(descriptionEdit, 'blur', () => this.edit('description'));

		EVENT.attach(titleEdit, 'keyup', (e: KeyboardEvent) => {
			if (e.key === 'Enter') {
				e.preventDefault();
				titleEdit.blur();
			} else if (e.key === 'Escape') {
				this.cancelEdit = true;
				titleEdit.blur();
			}
		});

		EVENT.attach(descriptionEdit, 'keyup', (e: KeyboardEvent) => {
			if (e.key === 'Enter') {
				e.preventDefault();
				descriptionEdit.blur();
			} else if (e.key === 'Escape') {
				this.cancelEdit = true;
				descriptionEdit.blur();
			}
		});

		this.frag.appendChild(this.thumbnail);
		this.frag.appendChild(owner);


		iPanelCreateDate.appendChild(dateCreatedLbl);
		iPanelCreateDate.appendChild(iPanelCreateDateTxt);
		iPanelEditDate.appendChild(dateEditedLbl);
		iPanelEditDate.appendChild(iPanelEditDateTxt);

		iPanelDate.appendChild(iPanelCreateDate);
		iPanelDate.appendChild(iPanelEditDate);

		infoHeader.appendChild(title);
		infoHeader.appendChild(titleLbl);
		infoHeader.appendChild(titleEdit);
		infoHeader.appendChild(iPanelDate);

		if (!iw.isGuest && !this.collection.isAnonLink) {
			for (let aclItem of this.collection.acl) {
				let memberItem = iwUI.createEl('span', {class: 'iPanel-initials'});
				memberItem.textContent = aclItem.Name.slice(0, 2).toUpperCase();
			}
		}

		descriptionWrap.append(description, descLbl, descriptionEdit);
	 	infoBody.append(descriptionWrap);
		infoFooter.append(this.numHits, mediaTypesWrap);
		mainContent.append(infoHeader, infoBody, infoFooter);
		this.frag.appendChild(mainContent);
	}

	/**
	 *
	 * @private
	 */
	private getThumb() {
		let item = this.collection.items[0],
			thumb;
		if (item) {
			if (item.Fields.thumbnail) {
				thumb = item.Fields.thumbnail;
			} else if (item.Fields.mediaType) {
				thumb = iwUI.imageFallback(item.Fields.mediaType)
			} else if (item.Fields.FullMediaTypes) {
				thumb = iwUI.imageFallback(item.Fields.FullMediaTypes.split(',')[0])
			}
		}
		return thumb;
	}

	/**
	 * Close panel
	 * @protected
	 */
	protected close() {
		EVENT.remove(document, 'CollectionInfo', this.eventListener)
	}
}